import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Home from "./pages/Home";
import AngelDetail from "./pages/AngelDetail";
import ClientDashboard from "./pages/ClientDashboard";
import ModelDashboard from "./pages/ModelDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import LegalPage from "./pages/LegalPage";
import AuthCallback from "./components/AuthCallback";
import AgeGate from "./components/AgeGate";
import ErrorBoundary from "./components/ErrorBoundary";
import useSiteSeo from "./hooks/useSiteSeo";

const Protected = ({ children, roles }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-[#6B6A63]">Cargando…</div>;
  if (!user) return <Navigate to="/" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
};

function AppInner() {
  const location = useLocation();
  useSiteSeo();

  // Global anti-download protection
  useEffect(() => {
    const blockContext = (e) => {
      if (e.target && (e.target.tagName === "IMG" || e.target.closest?.(".no-save"))) {
        e.preventDefault();
      }
    };
    const blockDrag = (e) => {
      if (e.target && e.target.tagName === "IMG") e.preventDefault();
    };
    const blockKeys = (e) => {
      // Block common save/copy shortcuts on images focus
      if ((e.ctrlKey || e.metaKey) && ["s"].includes(e.key.toLowerCase())) {
        e.preventDefault();
      }
    };
    document.addEventListener("contextmenu", blockContext);
    document.addEventListener("dragstart", blockDrag);
    document.addEventListener("keydown", blockKeys);
    return () => {
      document.removeEventListener("contextmenu", blockContext);
      document.removeEventListener("dragstart", blockDrag);
      document.removeEventListener("keydown", blockKeys);
    };
  }, []);

  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/angel/:id" element={<AngelDetail />} />
      <Route path="/privacidad" element={<LegalPage kind="privacy" />} />
      <Route path="/terminos" element={<LegalPage kind="terms" />} />
      <Route path="/dashboard" element={<Protected roles={["client", "model", "admin"]}><ClientDashboard /></Protected>} />
      <Route path="/dashboard/model" element={<Protected roles={["model", "admin"]}><ModelDashboard /></Protected>} />
      <Route path="/admin" element={<Protected roles={["admin"]}><AdminDashboard /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <AgeGate />
          <AppInner />
          <Toaster position="top-center" theme="light" />
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
